'use strict';

import React from 'react';

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { GetPaymentIntent } from '../../../actions/paymentActions'
import StripeCardElement from './StripeCardElement/StripeCardElement';
import { OnSchedUtils } from '../../../utils';


const StripePaymentForm = (element, onschedState) => {
  const [clientSecret, setClientSecret] = React.useState("");
  const stripePromise = loadStripe(element.options.payments?.publishableKey ? element.options.payments?.publishableKey : '');

  React.useEffect(() => {
    GetPaymentIntent(element).then(paymentIntentResponse => {
      setClientSecret(paymentIntentResponse.clientSecret);
    })
  }, []);
  
  const appearance = {
    theme: 'stripe',
    variables: {
      borderRadius: '8px',
    },
    rules: {
      '.Label': {
        color: '#fff',
        fontSize: '0px'
      },
      '.Input': {
        marginBottom: '5px',
        boxShadow: 'none',
        border: '1px solid #D8D8D8'
      },
      '.Input:hover': {
        border: '1px solid #6E75F8'
      },
      '.Input:focus': {
        boxShadow: 'none',
        outline: 'none',
        border: '1px solid #6E75F8'
      },
      '.Input:active': {
        boxShadow: 'none',
        outline: 'none',
        border: '1px solid #6E75F8'
      },
      '.Input--selected': {
        boxShadow: 'none',
        outline: 'none',
        border: '1px solid #6E75F8'
      }
    }
  };
  
  const options = {
    clientSecret,
    appearance,
  };

  // Loading for payments
  if (!clientSecret) {
    OnSchedUtils.Loading(element, true);
    return null;
  }
  else {
    OnSchedUtils.Loading(element, false);
  }

  if (!element.options.payments?.payments || 
      !element.options.payments?.publishableKey) {
    return null;
  }

  return (
    <div className='StripePaymentForm'>
      <Elements options={options} stripe={stripePromise}>
        <StripeCardElement />
      </Elements>
    </div>
  )
}

export default StripePaymentForm;